export type BadgeVariant = 'success' | 'warning' | 'error' | 'info' | 'gray' | 'purple' | 'teal';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const variantStyles: Record<BadgeVariant, string> = {
  success: 'bg-status-success-bg text-status-success-fg',
  warning: 'bg-status-warning-bg text-status-warning-fg',
  error:   'bg-status-error-bg text-status-error-fg',
  info:    'bg-status-info-bg text-status-info-fg',
  gray:    'bg-status-neutral-bg text-status-neutral-fg',
  purple:  'bg-accent-subagent-group-fg/15 text-accent-subagent-group-fg',
  teal:    'bg-accent-subagent-fg/15 text-accent-subagent-fg',
};

export default function Badge({
  children,
  variant = 'gray',
  className = '',
}: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${variantStyles[variant]} ${className}`}
    >
      {children}
    </span>
  );
}

// Convenience function to map status to variant
export function getStatusVariant(
  status: string
): BadgeVariant {
  switch (status.toLowerCase()) {
    case 'active':
    case 'ready':
    case 'success':
      return 'success';
    case 'inactive':
    case 'pending':
    case 'processing':
      return 'warning';
    case 'paused':
      return 'warning';
    case 'provisioning':
    case 'running':
      return 'info';
    case 'completed':
      return 'success';
    case 'archived':
    case 'failed':
    case 'error':
      return 'error';
    default:
      return 'gray';
  }
}
